import React from 'react'
import './ToggleButtonStyle.css';

const ToggleButton = ({checked, onChange}) => {
    return (
        <label className="switch">
            <input type="checkbox" checked={checked} onChange={onChange} />
                <span className="slider round"></span>
        </label>
    )
}

export default ToggleButton